import React, { useState } from "react";
import { FileEntityTypeWithUrl } from "../../../../../../hooks/useStorage";
import { FileInGallery } from "./file-in-gallery";
import { FileViewerModal } from "@components/file-viewer";
import { PdfTemplateType } from "../../../../../../pdf-templates/document-template.types";

export const FileGalleryInMessage: React.FC<{
  files: FileEntityTypeWithUrl[],
  messageOfCurrentOrg?: boolean,
  sharedUntil?: Record<string, string | null>,
  onShareFile?: (fileId: string) => void,
  onUnshareFile?: (fileId: string) => void,
  isAdmin: boolean,
}> = ({
  files,
  messageOfCurrentOrg = false,
  sharedUntil = {},
  onShareFile,
  onUnshareFile,
  isAdmin,
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState<string | null>(null);

  const handleFileClick = (fileId: string) => {
    setSelectedFileId(fileId);
    setIsViewerOpen(true);
  };

  const visibleFiles = files.filter(file => {
    const pdfType = (file.meta_data as any)?.pdf_template_type;
    if (pdfType === PdfTemplateType.SAMMELRECHNUNG) {
      return isAdmin;
    }
    return true;
  });

  // Recipients can't read a file once its share ended, but still see the share row.
  const unsharedFileIds = Object.entries(sharedUntil)
    .filter(([fileId, until]) => until && !files.some(file => file.id === fileId))
    .map(([fileId]) => fileId);

  const invisibleFiles = files.filter(file => {
    const pdfType = (file.meta_data as any)?.pdf_template_type;
    if (pdfType === PdfTemplateType.SAMMELRECHNUNG) {
      return !isAdmin;
    }
    return false;
  });

  return (
    <>
      <div className="flex flex-wrap gap-2 items-start">
        {visibleFiles.map(file => (
          <FileInGallery
            key={`file-${file.id}`}
            file={file}
            size="medium"
            messageOfCurrentOrg={messageOfCurrentOrg}
            sharedUntil={sharedUntil[file.id]}
            onShareFile={onShareFile}
            onUnshareFile={onUnshareFile}
            onFileClick={handleFileClick}
          />
        ))}
        {unsharedFileIds.map(fileId => (
          <FileInGallery
            key={`unshared-${fileId}`}
            file={{ id: fileId, file_name: null, path_name: null, url: "" }}
            size="medium"
            sharedUntil={sharedUntil[fileId]}
          />
        ))}
        {invisibleFiles.map(file => (
          <div key={`file-${file.id}`} className="text-sm text-gray-500">
            Sie haben nicht die Berechtigung, diese Datei anzusehen.
          </div>
        ))}
      </div>

      {/* File Viewer Modal */}
      <FileViewerModal
        fileIds={visibleFiles.map(f => f.id)}
        defaultFileId={selectedFileId || undefined}
        isOpen={isViewerOpen}
        onClose={() => {
          setIsViewerOpen(false);
          setSelectedFileId(null);
        }}
      />
    </>
  );
};